'use client';

import React from 'react';

import { useGetAboutUs } from '@/common/apis/dedicated-personal-page/about-us.api';
import DedicatedPersonalPage from '@/common/components/dedicated-personal-page/dedicated-personal-page.component';
import Loading from '@/common/components/loading';

const AboutUs = () => {
  const { data, isLoading } = useGetAboutUs();

  if (isLoading) return <Loading />;

  const content = data?.data.content;

  return <DedicatedPersonalPage content={content} title="درباره ما" />;
};

export default AboutUs;
